/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M13.6869 11.3374 12 6.1456l-1.6869 5.1918h-5.459l4.4164 3.2087-1.687 5.1918L12 16.5292l4.4164 3.2087-1.6869-5.1918 4.4164-3.2087h-5.459ZM0 9.7602h9.1672L12 1.0417l2.8328 8.7185H24l-7.4164 5.3883 2.8328 8.7185L12 18.4787 4.5836 23.867l2.8328-8.7185L0 9.7602Z"
    clipRule="evenodd"
  />,
  'Star'
);
